import React, { useRef, useMemo } from "react";
import { MeshReflectorMaterial, Plane, useTexture } from "@react-three/drei";
import { useControls, folder } from "leva";
import * as three from "three";
// * State
import useCustomizerStore from "../../../../state/customizer";
import useTransitionStore from "../../../../state/transitions";
import { ThemeConsumer } from "styled-components";
import { isMobile } from "react-device-detect";
import colorMap from "../../../../assets/textures/platform/BaseColor.jpg";
// import normalMap from "../../../../assets/textures/platform/Normal.jpg";
import normalMap from "../../../../assets/textures/platform/Normal.png";
import roughnessMap from "../../../../assets/textures/platform/Roughness.jpg";
import aoMap from "../../../../assets/textures/platform/AO.jpg";
import alphaMap from "../../../../assets/textures/platform/Opacity.jpg";
import metalnessMap from "../../../../assets/textures/platform/Metallic.jpg";

// import colorMap from "../../../../assets/textures/platform/BaseColor.jpg";
// import normalMap from "../../../../assets/textures/platform/Normal.jpg";
// import roughnessMap from "../../../../assets/textures/platform/Roughness.jpg";
// import aoMap from "../../../../assets/textures/platform/AO.jpg";
// import alphaMap from "../../../../assets/textures/platform/Opacity.jpg";
// import metalnessMap from "../../../../assets/textures/platform/Metallic.jpg";

// todo: need to instance to save on performance
export default React.memo(function Platform() {
  const model = useCustomizerStore((s) => s.model);
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const props = useTexture({
    map: colorMap,
    normalMap,
    // roughnessMap, //! causing glare when flipping platform
    aoMap,
    alphaMap,
    metalnessMap,
  });

  const group = useRef();

  const { rx, ry, rz, x, y, z, w, h } = useControls({
    Plane: folder({
      rx: { value: Math.PI, min: 0, max: Math.PI * 2, step: 1.0472 },
      ry: { value: 4.18, min: 0, max: Math.PI * 2, step: 1.0472 },
      rz: { value: 0, min: 0, max: Math.PI * 2, step: 1.0472 },
      x: { value: 1.38, min: -5, max: 5, step: 0.0001 },
      y: { value: 0, min: -3, max: 3, step: 0.0001 },
      z: { value: 0.79, min: -5, max: 5, step: 0.0001 },
      w: { value: 5.473281, min: 2, max: 15 }, //5.68
      h: { value: 15, min: 2, max: 15 },
    }),
  });
  const { ...params } = useControls({
    Reflection: folder({
      envMapIntensity: {
        value: 1,
        min: 0,
        max: 10,
        step: 0.01,
      },
      dithering: { value: true },
      roughness: { value: 1, min: 0, max: 1, step: 0.01 },
      mixBlur: { value: 30, min: 0, max: 150, step: 0.1 },
      mixStrength: { value: 40, min: 0, max: 150, step: 0.1 },
      mixContrast: { value: 1, min: 0, max: 15, step: 0.01 },
      minDepthThreshold: { value: 0.8, min: 0, max: 1, step: 0.01 },
      maxDepthThreshold: { value: 0.9, min: 0, max: 1, step: 0.01 },
      depthToBlurRatioBias: { value: 0.3, min: 0, max: 1, step: 0.01 },
      reflectorOffset: { value: 0.25, min: 0, max: 1, step: 0.01 },
      mirror: { value: 1, min: 0, max: 1, step: 1 }, //5.68
      depthScale: { value: 0.05, min: 0, max: 1 },
    }),
  });

  return (
    <group ref={group} dispose={null}>
      {/* xle */}
      <mesh
        // visible={model === 0 || DisplayMode == "flipper"}
        position={[0, 0, -1.575]} // z = -1.58
        rotation={[Math.PI, 0, 0]}
      >
        <Plane args={[w, h, 2, 2]}>
          {isMobile ? (
            <meshStandardMaterial color={"#000"} />
          ) : (
            <MeshReflectorMaterial
              // transparent
              {...props}
              {...params}
              // map={map}
              blur={[1000, 600]} // Blur ground reflections (width, heigt), 0 skips blur
              resolution={1024} // Off-buffer resolution, lower=faster, higher=better quality, slower
              debug={0}
              // envMapIntensity={1}
              // dithering={true}
              // roughness={1}
              // mixBlur={30} // How much blur mixes with surface roughness (default = 1) //30
              // mixStrength={40} // Strength of the reflections //80
              // mixContrast={1} // Contrast of the reflections
              // mirror={1} // Mirror environment, 0 = texture colors, 1 = pick up env colors
              // depthScale={0.05} // Scale the depth factor (0 = no depth, default = 0)
              // minDepthThreshold={0.8} // Lower edge for the depthTexture interpolation (default = 0)
              // maxDepthThreshold={0.9} // Upper edge for the depthTexture interpolation (default = 0)
              // depthToBlurRatioBias={0.3} // Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture
              // reflectorOffset={0.25} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
            />
          )}
          {/* <meshStandardMaterial color={"#ff00ff"} side={three.DoubleSide} /> */}
        </Plane>
      </mesh>
      {/* limited */}
      <mesh
        // visible={false}
        // visible={model === 1 || DisplayMode == "flipper"}
        position={[x, y, z]} //1.26, 0, 0.94
        rotation={[Math.PI, 2.09, 0]}
      >
        <Plane args={[w, h, 2, 2]}>
          {isMobile ? (
            <meshStandardMaterial color={"#000"} />
          ) : (
            <MeshReflectorMaterial
              // transparent
              {...props}
              {...params}
              // map={map}
              blur={[1000, 600]} // Blur ground reflections (width, heigt), 0 skips blur
              resolution={1024} // Off-buffer resolution, lower=faster, higher=better quality, slower
              // debug={0}
              // envMapIntensity={1}
              // dithering={true}
              // // color={[0.015, 0.015, 0.015]}
              // roughness={1}
              // mixBlur={30} // How much blur mixes with surface roughness (default = 1) //30
              // mixStrength={40} // Strength of the reflections //80
              // mixContrast={1} // Contrast of the reflections
              // mirror={1} // Mirror environment, 0 = texture colors, 1 = pick up env colors
              // depthScale={0.05} // Scale the depth factor (0 = no depth, default = 0)
              // minDepthThreshold={0.8} // Lower edge for the depthTexture interpolation (default = 0)
              // maxDepthThreshold={0.9} // Upper edge for the depthTexture interpolation (default = 0)
              // depthToBlurRatioBias={0.3} // Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture
              // reflectorOffset={0.25} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
            />
          )}
          {/* <meshStandardMaterial color={"#ffff00"} side={three.DoubleSide} /> */}
        </Plane>
      </mesh>
      {/* Platinum */}
      <mesh
        // visible={model === 2 || DisplayMode == "flipper"}
        position={[-x, y, z]}
        rotation={[Math.PI, 4.18, 0]}
      >
        <Plane args={[w, h, 2, 2]}>
          {isMobile ? (
            <meshStandardMaterial color={"#000"} />
          ) : (
            <MeshReflectorMaterial
              // transparent
              {...props}
              {...params}
              debug={0}
              blur={[1000, 600]} // Blur ground reflections (width, heigt), 0 skips blur
              resolution={1024} // Off-buffer resolution, lower=faster, higher=better quality, slower
              // envMapIntensity={1}
              // dithering={true}
              // // color={[0.015, 0.015, 0.015]}
              // roughness={1}
              // mixBlur={30} // How much blur mixes with surface roughness (default = 1) //30
              // mixStrength={40} // Strength of the reflections //80
              // mixContrast={1} // Contrast of the reflections
              // mirror={1} // Mirror environment, 0 = texture colors, 1 = pick up env colors
              // depthScale={0.05} // Scale the depth factor (0 = no depth, default = 0)
              // minDepthThreshold={0.8} // Lower edge for the depthTexture interpolation (default = 0)
              // maxDepthThreshold={0.9} // Upper edge for the depthTexture interpolation (default = 0)
              // depthToBlurRatioBias={0.3} // Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture
              // reflectorOffset={0.25} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
            />
          )}
          {/* <meshStandardMaterial color={"#ff0000"} side={three.DoubleSide} /> */}
        </Plane>
      </mesh>
    </group>
  );
});
